import { entity } from "@mhmo91/ican";
import { firestore } from "@mhmo91/ican/firestore/binding";
import { z } from "zod";
import { type Actor, Id } from "../workspace.entity.ts";
import { DomainSchema } from "./domain.entity.ts";

export const DomainCheckSchema = z
	.object({
		requestId: Id,
		domain: DomainSchema,
	})
	.strict();
export type DomainCheck = z.infer<typeof DomainCheckSchema>;

export const DomainCheck = entity<Actor>()({
	schema: DomainCheckSchema,
	actions: ["read"] as const,
})
	.pipe(({ can, hasPermission, and }) => [
		can("read").when((_data, me) =>
			and(
				hasPermission(me.permissions, "workspace.domains.manage"),
				me.mfa.eq(true),
			),
		),
	])
	.adaptor(
		firestore({
			hierarchicalGrants: true,
			path: "workspaces/{orgId}/domains/{hostname}/checks/current",
		}),
	);
